import { parentesco } from '@utils';
import {
  commons,
  death,
  parents,
  spouses,
  childs,
  certidaoGenitor,
  convivente,
  casoUniaoEstavel,
  others,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

const { constants } = parentesco;

export const HerdeiroLegalANDocs = () => {
  const rules = {
    anexoOutros: dynamicRule(),
    // anexoHerdeiro: dynamicRule('required'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    // anexoDeclaracaoHerdeiros: dynamicRule('required'),
    anexoCertidaoDeObito: dynamicRule('required'),

    anexoCertidaoCasamentoOuNascimento: dynamicRule('pais'),
    anexoCertidaoCasamento: dynamicRule('casamento'),
    anexoCertidaoNascimento: dynamicRule('nascimento'),
    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),

    anexoConvivente: dynamicRule('convivente'),
    anexoCasoUniaoEstavel: dynamicRule(),
  };

  const docs = {
    commons: [...commons, ...death, ...others],
    [constants.PAI]: parents,
    [constants.MAE]: parents,
    [constants.CONJUGE]: spouses,
    [constants.EX_CONJUGE]: spouses,
    [constants.FILHO]: childs,
    [constants.CONVIVENTE]: [...convivente, ...casoUniaoEstavel],
    [constants.ENTEADO]: [...childs, ...certidaoGenitor],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
